import '../App.js';
import Tags from './Tags'

function Post(props) {
    const { title, creationDate, author, description, link, tags } = props;
    return (
        <div class={`post post-${props.postIndex % 2 === 0 ? 'even' : 'odd' }`}>
            <a class='nav-link' href={ link }> 
                <div class='post-info'>
                    <Tags tagsLoaded = { tags } />
                    <span class='post-title'>
                        { title } 
                    </span>
                    <p class='post-description'>
                        { description }
                    </p>
                    <div class='post-info-author-date'>
                        <span class='post-author'>
                            { author }, 
                            <span class='post-date'> { creationDate } </span>
                        </span>
                    </div>
                </div>
            </a>
        </div>
    )
};

export default Post;